import {
  SubscriptionOverview,
  CreatePaymentIntentResponse,
  CreateCardWithIntentPayload,
  CreateCardWithIntentResponse,
  UpdateBillingAddressPayload,
  BillingInfoPayload,
} from './interfaces';
import { useFetch, usePost, usePut } from '@selfserve/react-hooks';
import { apiEndpoints, IIndexSignature } from '@selfserve/react-utils';

export const useSubscriptionOverviewRequest = (enabled = true) =>
  useFetch<SubscriptionOverview>(apiEndpoints.subscriptionOverview, undefined, {
    enabled,
  });

export const useCreatePaymentIntent = (amount: number) =>
  usePost<any, CreatePaymentIntentResponse>(
    apiEndpoints.createPaymentIntent.replace(':amount', String(amount))
  );

export const useCreateCardWithIntent = () =>
  usePut<CreateCardWithIntentPayload, any>(
    apiEndpoints.createCardWithIntent
  );

export const useUpdateBillingAddress = () =>
  usePost<UpdateBillingAddressPayload, any>(apiEndpoints.updateBillingAddress);

export const useBillingInfoRequest = () =>
  usePut<BillingInfoPayload, any>(apiEndpoints.billingInfo);

export const useKavaRequest = (options: IIndexSignature<string>) =>
  useFetch<any>(
    apiEndpoints.kava,
    options,
    {
      enabled: false,
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retryOnMount: false,
    },
    true
  );

export const usePurchaseManagerVersionRequest = () =>
  useFetch<any>(apiEndpoints.purchaseManagerVersion, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const usePackageManagerVersionRequest = () =>
  useFetch<any>(apiEndpoints.packageManagerVersion, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const useChargebeeWebhookVersionRequest = () =>
  useFetch<any>(apiEndpoints.chargebeeWebhookVersion, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const usePurchaseManagerErrorsRequest = () =>
  useFetch<any>(apiEndpoints.purchaseManagerErrors, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const usePackageManagerErrorsRequest = () =>
  useFetch<any>(apiEndpoints.packageManagerErrors, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const useChargebeeWebhookErrorsRequest = () =>
  useFetch<any>(apiEndpoints.chargebeeWebhookErrors, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export const scannerErrorsRequest = () =>
  useFetch<any>(apiEndpoints.scannerErrors, undefined, {
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retryOnMount: false,
  });

export * from './interfaces';
export * from './schemas';
